import React from 'react';
import PropTypes from 'prop-types';
import { ideaShape } from 'src/api/task';

// Components
import { AddButton } from 'src/react/components/buttons';

// Helpers
import useActionWithDisabled from 'src/react/helpers/useActionWithDisabled';
import daysToCompletion from 'src/react/helpers/days_to_completion';

const RecommendationIdea = (props) => {
  const { idea, onAddClick, onSkipClick, onShowDetailsClick } = props;
  const { isDisabled, wrapAction } = useActionWithDisabled();

  return (
    <div className="RecommendationIdea-container w-full sm:w-auto flex flex-col">
      <div className="mb-auto pb-2" data-testid="recommendation_idea">
        <h2 className="font-semibold leading-none text-6 sm:text-8">
          {idea.title}
        </h2>
        <p className="mx-auto text-center RecommendationIdea-description text-4 text-gray-70">
          {idea.summary}
        </p>
        {idea.days_to_completion ? (
          <p className="mb-2 text-4 text-gray-70">
            Complete in{' '}
            <span className="font-semibold">
              {daysToCompletion(idea.days_to_completion)}
            </span>
            .
          </p>
        ) : null}
        <span
          className="font-semibold text-blue-40 cursor-pointer text-4"
          onClick={onShowDetailsClick}
          onKeyUp={onShowDetailsClick}
          data-testid="learn_more"
          role="button"
          tabIndex="0"
        >
          Learn More
        </span>
      </div>
      <div className="flex w-full sm:w-auto flex-col sm:flex-row justify-center">
        <AddButton
          className="w-full sm:w-auto mb-1 sm:mb-0 sm:ml-1 select-none"
          size="large"
          onClick={wrapAction(onAddClick, idea)}
          data-testid="add_recommendation"
          disabled={isDisabled}
        />
        <button
          onClick={wrapAction(onSkipClick, idea)}
          className="w-full sm:w-auto ml-0 sm:ml-1 rds-Button rds-Button--ghost rds-Button--large select-none"
          data-testid="skip_recommendation"
          disabled={isDisabled}
        >
          Not Now
        </button>
      </div>
    </div>
  );
};

export default RecommendationIdea;

RecommendationIdea.propTypes = {
  idea: ideaShape,
  setNoRecommendation: PropTypes.func,
  onAddClick: PropTypes.func,
  onSkipClick: PropTypes.func,
  onShowDetailsClick: PropTypes.func
};
